import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { MDF_RAW_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-loaded components
const MdfInventoryList = lazy(() => import("app/pages/Inventory/Mdf Inventory/ListMdf"));
const AddMdfStock = lazy(() => import("app/pages/Inventory/Mdf Inventory/AddMdf"));
const EditMdfStock = lazy(() => import("app/pages/Inventory/Mdf Inventory/EditMdf"));
const ViewDetails = lazy(() => import("app/pages/Inventory/Mdf Inventory/ListMdf/Approval/ViewDetails"));
const IssueRawOrderMDF = lazy(() => import("app/pages/Inventory/Mdf Inventory/IssueRawOrder"));

export const mdfInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "mdf_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/mdf",
        element: LoadablePage(MdfInventoryList),
      },
      {
        path: "/inventory/mdf/add",
        element: LoadablePage(AddMdfStock),
      },
      {
        path: "/inventory/mdf/edit",
        element: LoadablePage(EditMdfStock),
      },
      {
        path: "/inventory/mdf-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: MDF_RAW_ORDER,
        element: LoadablePage(IssueRawOrderMDF),
      },
    ],
  },
];
